import {
  HttpEvent,
  HttpHandler,
  HttpHandlerFn,
  HttpInterceptor,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { PLUGIN_REQUEST_ORIGIN } from '@plugins/shared/constants';

import { AuthService } from './auth.service';

export const interceptAuth = (
  req: HttpRequest<unknown>,
  nextHandler: HttpHandler | HttpHandlerFn,
  authService: AuthService,
) => {
  const next = 'handle' in nextHandler ? nextHandler.handle : nextHandler;
  const sameOrigin =
    window.location.origin === new URL(req.url, window.location.href).origin;

  const pluginContext = {
    [PLUGIN_REQUEST_ORIGIN.header]: window.location.pathname.includes('admin')
      ? PLUGIN_REQUEST_ORIGIN.values.admin
      : PLUGIN_REQUEST_ORIGIN.values.user,
  };
  const apiPrefix = req.url.startsWith('/api');

  if (sameOrigin && apiPrefix && authService.isLoggedIn()) {
    return next(
      req.clone({
        setHeaders: {
          Authorization: `token ${authService.authToken}`,
          ...pluginContext,
        },
      }),
    );
  }
  // else don't touch request
  return next(req);
};

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return interceptAuth(req, next, this.authService);
  }
}

export const authInterceptorFn: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const authService = inject(AuthService);
  return interceptAuth(req, next, authService);
};

@Injectable()
export class HttpMockRequestInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request);
  }
}

export const httpMockRequestInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  return next(req);
};
